import React from "react";
import { Modal } from "react-bootstrap";
import CustomizButton from "../buttons/CustomizButton";

const CustomModal = ({
  show,
  handleClose,
  title = "title",
  secondaryButtonLable,
  primaryButtonLable,
  renderModalContent,
  secondaryClick,
  primaryClick,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="sub-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderModalContent}</Modal.Body>
      <Modal.Footer>
        {secondaryButtonLable && (
          <CustomizButton
            label={secondaryButtonLable}
            variant="secondary"
            onClick={secondaryClick}
          />
        )}

        {primaryButtonLable && (
          <CustomizButton
            label={primaryButtonLable}
            variant="primary"
            onClick={primaryClick}
          />
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
